module.exports = __webpack_public_path__ + "img/back1.b350672a.svg";